import {Component, forwardRef, Injector, Input, OnInit} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractMultiSelectEditControlComponent
} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MonthOfYearMultiSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-month-of-year-multi-select-edit-control",
    templateUrl: "../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR
    ]
})
export class MonthOfYearMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<any> implements OnInit {
    @Input() useMonthNameValues: boolean = false;

    constructor(injector: Injector) {
        super(undefined, injector);
    }

    override ngOnInit() {
        this.buildData([
            {label: "wbo.common.month.january", value: this.useMonthNameValues ? "Jan" : "1"},
            {label: "wbo.common.month.february", value: this.useMonthNameValues ? "Feb" : "2"},
            {label: "wbo.common.month.march", value: this.useMonthNameValues ? "Mar" : "3"},
            {label: "wbo.common.month.april", value: this.useMonthNameValues ? "Apr" : "4"},
            {label: "wbo.common.month.may", value: this.useMonthNameValues ? "May" : "5"},
            {label: "wbo.common.month.june", value: this.useMonthNameValues ? "Jun" : "6"},
            {label: "wbo.common.month.july", value: this.useMonthNameValues ? "Jul" : "7"},
            {label: "wbo.common.month.august", value: this.useMonthNameValues ? "Aug" : "8"},
            {label: "wbo.common.month.september", value: this.useMonthNameValues ? "Sep" : "9"},
            {label: "wbo.common.month.october", value: this.useMonthNameValues ? "Oct" : "10"},
            {label: "wbo.common.month.november", value: this.useMonthNameValues ? "Nov" : "11"},
            {label: "wbo.common.month.december", value: this.useMonthNameValues ? "Dec" : "12"}]);
        super.ngOnInit();
    }
}
